import React, { useState, useEffect } from "react";

import { APP_USER_PROFILE, APP_USER_PROFILE_RESULT } from "configs/constants";

import Form from "components/Form";
import Table from "components/Table";
import * as Yup from "yup";
import Alert from "@material-ui/lab/Alert";
import { Paper } from "@material-ui/core";
import { useTranslation } from "react-i18next";


import eightAxios from "configs/axiosConfig";
import LoadingIcon from "@Components/LoadingIcon/LoadingIcon";
import axios from "axios";

let model = [
  { id: "SN", label: "SN", type: "string" },
  { id: "employee_id", label: "Employee ID", type: "string" },
  { id: "mobile_number", label: "Mobile Number", type: "string" },
  { id: "region_name", label: "Region Name", type: "string" },
  { id: "estate_name", label: "Estate Name", type: "string" },
  { id: "division_name", label: "Division Name", type: "string" },
  { id: "block_name", label: "Block Name", type: "string" },
  { id: "status", label: "Status", type: "string" },
  { id: "remarks", label: "Remarks", type: "string" },
];

const initialValues = {};

const SUPPORTING_DOCUMENT_FORMATS = [
  ".csv",
  "text/csv",
  "application/vnd.ms-excel",
];

const detailURL = "/configuration/get-config/";
const templateURL = "download-template/?type=app_user";
const FileDownload = require("js-file-download");

const AppUserProfileUpload = () => {
  const { t } = useTranslation();

  const [displayTable, setDisplayTable] = useState(false);
  const [buttonCounter, setButtonCounter] = useState(0);
  const [tableData, setTableData] = useState(null);
  const [fileSize, setFileSize] = useState(null);
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object({
    file: Yup.mixed()
      .test("fileType", "Unsupported file type", (value) => {
        if (value === null) {
          return false;
        } else if (typeof value === "string") {
          return true;
        } else {
          return SUPPORTING_DOCUMENT_FORMATS.includes(value.type);
        }
      })
      .test("fileSize", "File is too large", (value) => {
        if (value === null) {
          return false;
        } else if (typeof value === "string") {
          return true;
        } else {
          return value.size <= fileSize;
        }
      }),
  });

  const fetchDetails = () => {
    setLoading(true);
    eightAxios
      .get(detailURL)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.max_file_upload_size) {
            setFileSize(response.data.max_file_upload_size * 1024 * 1024);
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response);
        }
        setLoading(false);
      });
  };

  const fetchTemplate = () => {
    setLoading(true);
    const API_VERSION = "v1";
    const API_URL = process.env.REACT_APP_API_URL;
    let baseURL = `${API_URL}${API_VERSION}/`;
    const headers = {
      Authorization: `JWT ${localStorage.getItem("token")}`,
    };
    axios({
      url: baseURL + templateURL,
      method: "get",
      headers: headers,
      responseType: "blob",
    })
      .then(function (response) {
        FileDownload(response.data, "Worker_upload_template.csv");
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  const formFields = [
    {
      type: "fileupload",
      name: "file",
      accept: ".csv",
      label: "App User Profile File",
      supportedTypes: [t("csv file only")],
      buttonText: "Browse",
    },
  ];

  const formButtons = [
    {
      type: "submit",
      label: "Submit",
      color: "primary",
    },
  ];

  if (loading) {
    return <LoadingIcon image text="Loading" />;
  }

  return (
    <div>
      <Paper style={{ padding: "10px" }}>
        <Form
          initialValues={initialValues}
          submitUrl={APP_USER_PROFILE}
          formFields={formFields}
          formButtons={formButtons}
          afterSubmit={(success) => {
            if (success) {
              setDisplayTable(true);
              setButtonCounter(buttonCounter + 1);
            }
          }}
          isMultipart
          formTitle="App User Profile Upload"
          validationSchema={validationSchema}
          noTypography={true}
          noFeature={true}
          downloadTemplate={fetchTemplate}
          
        />
        {tableData && tableData.extra ? (
          <Alert
            severity={tableData.extra.failed > 0 ? "error" : "success"}
            style={{ marginTop: "10px", marginBottom: "10px" }}
          >
            {`Total: ${
              tableData.extra.success + tableData.extra.failed
            }, Successful: ${tableData.extra.success}, Failed: ${
              tableData.extra.failed
            }`}
          </Alert>
        ) : null}
      </Paper>
      {displayTable ? (
        <Table
          model={model}
          noFilter
          proxyURL={APP_USER_PROFILE_RESULT}
          outerFetchTrigger={buttonCounter}
          noAddButton
          excelExport={{ fileName: "WorkerResult" }}
          polling
          setTableData={setTableData}
        />
      ) : null}
    </div>
  );
};

export default AppUserProfileUpload;
